export var isMarketQA = function (market) {
    return market.id
        ? market.id.indexOf("_") < 0
        : false;
};
//# sourceMappingURL=isMarketQA.js.map